import React from 'react';
import { ScrollView } from 'react-native';
import { HStack } from '@/components/gluestack/hstack';

interface ActionBarProps {
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
}

export function ActionBar({ leftSection, rightSection }: ActionBarProps) {
  return (
    <HStack className="w-full h-16 items-center border-b border-b-background-200/50 bg-background-0 py-2">
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        bounces={true}
        contentContainerStyle={{
          minWidth: '100%',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <HStack space="sm" className="pl-4">{leftSection}</HStack>
        <HStack space="sm" className="pr-4">{rightSection}</HStack>
      </ScrollView>
    </HStack>
  );
}
